enum VERSIONS {
  PRE_RELEASE = '0.0.1',
}
const ID = 'client-hub:store'

const DEFAULT_CLIENT_SLUG = 'bwell'

const DEFAULT_FRONTEND_ENVIRONMENT = 'bwell'

const API_REQUEST_TIMEOUT = 10000

export { VERSIONS, ID, DEFAULT_CLIENT_SLUG, API_REQUEST_TIMEOUT, DEFAULT_FRONTEND_ENVIRONMENT }
